import React from 'react'


export default function PiedDePage() {
    return (
        <footer className="piedDePage">
            pied de page
        </footer>
    )
}
